import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { finalize } from 'rxjs';
import { LOADING_ANIMATION, LOADING_MESSAGE, SHOW_LOADING } from '../core/api/api-context';
import { LoadingService } from '../core/loading/loading.service';

/**
 * Loading interceptor — drives the global loading overlay for OPT-IN requests.
 *
 * Only requests that set `SHOW_LOADING` on their HttpContext (via
 * `ApiHandlerService`'s `showLoading` flag) are counted. Everything else is a
 * no-op, so existing screens with their own skeleton/inline loaders are
 * unaffected. `finalize` guarantees the count is decremented on success, error,
 * or cancellation — and because this interceptor sits outside the auth
 * interceptor, a 401-triggered refresh+retry still counts as a single request.
 */
export const loadingInterceptor: HttpInterceptorFn = (req, next) => {
  if (!req.context.get(SHOW_LOADING)) {
    return next(req);
  }
  const loading = inject(LoadingService);
  loading.start(req.context.get(LOADING_MESSAGE), req.context.get(LOADING_ANIMATION));
  return next(req).pipe(finalize(() => loading.stop()));
};
